import clsx from "clsx";

export const Loader = ({ className }: { className?: string }) => (
  <svg role="status" aria-label="Sending" className={clsx("size-5 animate-spin", className)} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.3" strokeWidth="3" />
    <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
